module.exports = __webpack_public_path__ + "static/img/reward_get_none.ea53cdda.png";